import { formatDate } from '@/utils/date';

export type LiceReportPeriodSource = {
    day?: string;
    from?: string;
    to?: string;
    isoWeek?: number;
    isoYear?: number;
    interimReport?: boolean;
};

export function getDailyLiceReportPeriodLabel(
    dailySubMode: 'single' | 'range',
    selectedDate: string,
    rangeFrom: string,
    rangeTo: string
): string {
    if (dailySubMode === 'range') {
        return `${formatDate(rangeFrom, 'displayLong')} - ${formatDate(rangeTo, 'displayLong')}`;
    }
    return formatDate(selectedDate, 'displayLong');
}
